module.exports = __webpack_public_path__ + "static/img/main_product.6d72767.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/main_product.png
// module id = fLBo
// module chunks = 0